import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useRef } from 'react'

import { useSiteAnimations } from '@/hooks/animations'

import { Nav } from './nav'
import { Footer } from './footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    const rootRef = useRef<HTMLDivElement>(null)

    useSiteAnimations(rootRef)

    return (
        <div ref={rootRef} className='page-root'>
            <Nav />
            <main>{children}</main>
            <Footer />
        </div>
    )
}
